<template>
  <div class="registration">
    <h4 v-if="$route.path.match(new RegExp('^\/persons', 'i'))">{{ _.registration_statuses }}</h4>
    <h4 v-if="$route.path.match(new RegExp('^\/person/[0-9]+/edit', 'i'))">{{ _.registration_status }}</h4>
    <p style="padding-top: 4px;">
      <button v-if="$route.path.match(new RegExp('^\/persons', 'i'))" @click="updateRegistrationStatuses(persons.map(person => person.id).join(','))">{{ _.update_filtered }}</button><br>
      <button v-if="$route.path.match(new RegExp('^\/persons', 'i'))" @click="updateRegistrationStatuses()">{{ _.update_all }}</button>
      <button v-if="$route.path.match(new RegExp('^\/person/[0-9]+/edit', 'i'))" @click="updateRegistrationStatus()">{{ _.update }}</button>
    </p>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  data() {
    return {
      update: false,
    }
  },
  computed: {
    ...mapGetters('persons', ['persons']),
    ...mapGetters('person', ['person']),
  },
  methods: {
    ...mapMutations('persons', ['clearList']),
    ...mapActions('persons', ['getList']),
    ...mapActions('person', ['getPerson']),
    ...mapActions('person_edit', ['getForm']),
    async updateRegistrationStatuses(ids) {
      if (this.update) return;
      const params = ids ? '?ids=' + ids : '';
      this.update = true;
      await this.axios.get(API_URL + '/persons/registration' + params);
      this.clearList();
      await this.getList();
      this.setProgress(false);
      this.update = false;
    },
    async updateRegistrationStatus() {
      if (this.update) return;
      await this.axios.get(API_URL + '/persons/' + this.person.id + '/registration');
      await this.getPerson();
      await this.getForm();
      this.setProgress(false);
      this.update = false;
    },
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.registration {
  border-top: 1px solid lighten($primary-color, 80%);
  > p {
    > button {
      margin-bottom: 6px;
    }
  }
}
</style>